import React from "react";
import styled from "styled-components";

import { Typography } from "@material-ui/core";

const StyledDiv = styled.div`
  color: ${(props) => props.theme.palette.secondary.light};
  padding-bottom: 4vh;
  text-align: center;
`;

const Title = (props) => {
  return (
    <StyledDiv>
      <Typography variant="h1">{props.title}</Typography>
      {props.subheading && (
        <Typography variant="h3">{props.subheading}</Typography>
      )}
    </StyledDiv>
  );
};

export default Title;
